<template>
  <div>
    <v-tooltip bottom v-if="!defaultTemplate">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="mr-1"
          icon
          x-small
          v-bind="attrs"
          v-on="on"
          @click="$emit('edit')"
        >
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("template.lblEditTemplate") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="!defaultTemplate">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          v-bind="attrs"
          v-on="on"
          class="mr-1"
          @click="$emit('delete')"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("template.lblDeleteTemplate") }}</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          v-bind="attrs"
          v-on="on"
          @click="$emit('copy')"
        >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("template.tipCopyTemplate") }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "ActionTemplate",
  props: {
    defaultTemplate: {
      type: Boolean,
      default: false
    },
  },
};
</script>

<style>
</style>